export default "__VITE_ASSET__V$N6$R74__"